import styles from "./CityPropositionsBlock.module.scss";

export type CityPropositionsBlockProps = {
  title?: string;
  subtitle?: string;
  cityPropositions?: {
    title: string;
    url: string;
  }[];
};

export const CityPropositionsBlock = ({
  title,
  subtitle,
  cityPropositions,
}: CityPropositionsBlockProps) => {
  return (
    <div className={styles.cityPropositionsBlock}>
      {title !== undefined && <h2 className={styles.title}>{title}</h2>}
      {subtitle !== undefined && (
        <div className={styles.subtitle}>{subtitle}</div>
      )}
      {cityPropositions !== undefined && (
        <div className={styles.cityPropositions}>
          {cityPropositions.map((proposition) => {
            return (
              <div key={proposition.title} className={styles.proposition}>
                <a href={proposition.url} className={styles.link}>
                  {proposition.title}
                </a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
